// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * jQuery QueryBuilder 2.7.0
 * Copyright 2014-2023 Damien "Mistic" Sorel (http://www.strangeplanet.fr)
 * Licensed under MIT (https://opensource.org/licenses/MIT)
 */
.query-builder {
  position: relative;
  margin: 4px 0;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #eee;
  background: rgba(255, 255, 255, 0.9);
}

.query-builder .rule-placeholder,
.query-builder .rule-container,
.query-builder .rules-group-container {
  position: relative;
  margin: 4px 0;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #eee;
  background: rgba(255, 255, 255, 0.9);
}

.query-builder .drag-handle,
.query-builder .error-container,
.query-builder .rule-container .rule-filter-container,
.query-builder .rule-container .rule-operator-container,
.query-builder .rule-container .rule-value-container {
  display: inline-block;
  margin: 0 5px 0 0;
  vertical-align: middle;
}

.query-builder .rules-group-container {
  padding: 10px;
  padding-bottom: 6px;
  border: 1px solid #dcc896;
  background: rgba(250, 240, 210, 0.5);
}
.query-builder .rules-group-header {
  margin-bottom: 10px;
}
.query-builder .rules-group-header .group-conditions .btn.readonly:not(.active),
.query-builder .rules-group-header .group-conditions input[name\$="_cond"] {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
}
.query-builder .rules-group-header .group-conditions .btn.readonly {
  border-radius: 3px;
}
.query-builder .rules-list {
  list-style: none;
  padding: 0 0 0 15px;
  margin: 0;
}
.query-builder .rule-value-container {
  border-left: 1px solid #ddd;
  padding-left: 5px;
}
.query-builder .rule-value-container label {
  margin-bottom: 0;
  font-weight: normal;
}
.query-builder .rule-value-container label.block {
  display: block;
}
.query-builder .rule-value-container select,
.query-builder .rule-value-container input[type="text"],
.query-builder .rule-value-container input[type="number"] {
  padding: 1px;
}
.query-builder .error-container {
  display: none;
  cursor: help;
  color: #f00;
}
.query-builder .has-error {
  background-color: #fdd;
  border-color: #f99;
}
.query-builder .has-error .error-container {
  display: inline-block !important;
}
.query-builder .rules-list > *::before,
.query-builder .rules-list > *::after {
  content: "";
  position: absolute;
  left: -10px;
  width: 10px;
  height: calc(50% + 4px);
  border-color: #aaa;
  border-style: solid;
}
.query-builder .rules-list > *::before {
  top: -4px;
  border-width: 0 0 2px 2px;
}
.query-builder .rules-list > *::after {
  top: 50%;
  border-width: 0 0 0 2px;
}
.query-builder .rules-list > *:first-child::before {
  top: -12px;
  height: calc(50% + 14px);
}
.query-builder .rules-list > *:last-child::before {
  border-radius: 0 0 0 4px;
}
.query-builder .rules-list > *:last-child::after {
  display: none;
}

.query-builder.bt-checkbox-glyphicons
  .checkbox
  input[type="checkbox"]:checked
  + label::after {
  font-family: "Glyphicons Halflings";
  content: "\\e013";
}
.query-builder.bt-checkbox-glyphicons .checkbox label::after {
  padding-left: 4px;
  padding-top: 2px;
  font-size: 9px;
}

.query-builder .error-container + .tooltip .tooltip-inner {
  color: #f99 !important;
}

.query-builder p.filter-description {
  margin: 5px 0 0 0;
  background: #d9edf7;
  border: 1px solid #bce8f1;
  color: #31708f;
  border-radius: 5px;
  padding: 2.5px 5px;
  font-size: 0.8em;
}

.query-builder .rules-group-header [data-invert] {
  margin-left: 5px;
}

.query-builder .drag-handle {
  cursor: move;
  vertical-align: middle;
  margin-left: 5px;
}
.query-builder .dragging {
  position: fixed;
  opacity: 0.5;
  z-index: 100;
}
.query-builder .dragging::before,
.query-builder .dragging::after {
  display: none;
}
.query-builder .rule-placeholder {
  border: 1px dashed #bbb;
  opacity: 0.7;
}

/*
*/
.svg-font-color svg > path {
  fill: var(--ifm-font-color-base);
}

.donut-hole {
  overflow-y: unset !important;
}

.queryBuilder {
  min-width: 420px;
}

li.tabs__item {
  white-space: nowrap;
}

/* Styles for when "Use validation" option is selected */
.validateQuery .queryBuilder {
  & .ruleGroup.queryBuilder-invalid {
    /* Color invalid groups */
    background-color: color-mix(in srgb, rebeccapurple, transparent 60%);

    & .ruleGroup-addRule {
      /* Bold the "+ Rule" button if the group has no child rules or groups */
      font-weight: bold !important;
    }

    & > .ruleGroup-body {
      display: block;
    }

    & > .ruleGroup-body::after {
      /* Message to user about empty groups */
      content: "Empty groups are considered invalid. Avoid them by using addRuleToNewGroups.";
      color: white;
    }
  }

  & .rule.queryBuilder-invalid .rule-value {
    /* Purple background for empty text fields */
    background-color: color-mix(in srgb, rebeccapurple, transparent 60%);

    &::placeholder {
      color: color-mix(in srgb, rebeccapurple, black 30%);
    }
  }
}

/* Styles for when "Use validation" option is selected (dark theme variations) */
html[data-theme="dark"]
  .validateQuery
  .queryBuilder
  .rule.queryBuilder-invalid
  .rule-value::placeholder {
  color: color-mix(in srgb, rebeccapurple, white 30%);
}

.tabs-container .tabs-container li {
  font-size: smaller;
  padding: var(--ifm-badge-padding-vertical) var(--ifm-badge-padding-horizontal);
}

/*.results-auto li:not(:last-child)::after {
  content: "."; /* Change to "•" for a dot * /
  margin-left: 15px;
  color: #aaa;
}*/

/* Adds a line under every item except the last one */
.results-auto li:not(:last-child) {
  border-bottom: 1px solid #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Configuraciones/query.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;EAGE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;;;EAKE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;;;;EAIE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;CACC;AACD;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE;IACE,yBAAyB;IACzB,oEAAoE;;IAEpE;MACE,uEAAuE;MACvE,4BAA4B;IAC9B;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,uCAAuC;MACvC,uFAAuF;MACvF,YAAY;IACd;EACF;;EAEA;IACE,4CAA4C;IAC5C,oEAAoE;;IAEpE;MACE,mDAAmD;IACrD;EACF;AACF;;AAEA,gFAAgF;AAChF;;;;;EAKE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA;;;;EAIE;;AAEF,qDAAqD;AACrD;EACE,6BAA6B;AAC/B","sourcesContent":["/*!\n * jQuery QueryBuilder 2.7.0\n * Copyright 2014-2023 Damien \"Mistic\" Sorel (http://www.strangeplanet.fr)\n * Licensed under MIT (https://opensource.org/licenses/MIT)\n */\n.query-builder {\n  position: relative;\n  margin: 4px 0;\n  border-radius: 5px;\n  padding: 5px;\n  border: 1px solid #eee;\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.query-builder .rule-placeholder,\n.query-builder .rule-container,\n.query-builder .rules-group-container {\n  position: relative;\n  margin: 4px 0;\n  border-radius: 5px;\n  padding: 5px;\n  border: 1px solid #eee;\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.query-builder .drag-handle,\n.query-builder .error-container,\n.query-builder .rule-container .rule-filter-container,\n.query-builder .rule-container .rule-operator-container,\n.query-builder .rule-container .rule-value-container {\n  display: inline-block;\n  margin: 0 5px 0 0;\n  vertical-align: middle;\n}\n\n.query-builder .rules-group-container {\n  padding: 10px;\n  padding-bottom: 6px;\n  border: 1px solid #dcc896;\n  background: rgba(250, 240, 210, 0.5);\n}\n.query-builder .rules-group-header {\n  margin-bottom: 10px;\n}\n.query-builder .rules-group-header .group-conditions .btn.readonly:not(.active),\n.query-builder .rules-group-header .group-conditions input[name$=\"_cond\"] {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  white-space: nowrap;\n}\n.query-builder .rules-group-header .group-conditions .btn.readonly {\n  border-radius: 3px;\n}\n.query-builder .rules-list {\n  list-style: none;\n  padding: 0 0 0 15px;\n  margin: 0;\n}\n.query-builder .rule-value-container {\n  border-left: 1px solid #ddd;\n  padding-left: 5px;\n}\n.query-builder .rule-value-container label {\n  margin-bottom: 0;\n  font-weight: normal;\n}\n.query-builder .rule-value-container label.block {\n  display: block;\n}\n.query-builder .rule-value-container select,\n.query-builder .rule-value-container input[type=\"text\"],\n.query-builder .rule-value-container input[type=\"number\"] {\n  padding: 1px;\n}\n.query-builder .error-container {\n  display: none;\n  cursor: help;\n  color: #f00;\n}\n.query-builder .has-error {\n  background-color: #fdd;\n  border-color: #f99;\n}\n.query-builder .has-error .error-container {\n  display: inline-block !important;\n}\n.query-builder .rules-list > *::before,\n.query-builder .rules-list > *::after {\n  content: \"\";\n  position: absolute;\n  left: -10px;\n  width: 10px;\n  height: calc(50% + 4px);\n  border-color: #aaa;\n  border-style: solid;\n}\n.query-builder .rules-list > *::before {\n  top: -4px;\n  border-width: 0 0 2px 2px;\n}\n.query-builder .rules-list > *::after {\n  top: 50%;\n  border-width: 0 0 0 2px;\n}\n.query-builder .rules-list > *:first-child::before {\n  top: -12px;\n  height: calc(50% + 14px);\n}\n.query-builder .rules-list > *:last-child::before {\n  border-radius: 0 0 0 4px;\n}\n.query-builder .rules-list > *:last-child::after {\n  display: none;\n}\n\n.query-builder.bt-checkbox-glyphicons\n  .checkbox\n  input[type=\"checkbox\"]:checked\n  + label::after {\n  font-family: \"Glyphicons Halflings\";\n  content: \"\\e013\";\n}\n.query-builder.bt-checkbox-glyphicons .checkbox label::after {\n  padding-left: 4px;\n  padding-top: 2px;\n  font-size: 9px;\n}\n\n.query-builder .error-container + .tooltip .tooltip-inner {\n  color: #f99 !important;\n}\n\n.query-builder p.filter-description {\n  margin: 5px 0 0 0;\n  background: #d9edf7;\n  border: 1px solid #bce8f1;\n  color: #31708f;\n  border-radius: 5px;\n  padding: 2.5px 5px;\n  font-size: 0.8em;\n}\n\n.query-builder .rules-group-header [data-invert] {\n  margin-left: 5px;\n}\n\n.query-builder .drag-handle {\n  cursor: move;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n.query-builder .dragging {\n  position: fixed;\n  opacity: 0.5;\n  z-index: 100;\n}\n.query-builder .dragging::before,\n.query-builder .dragging::after {\n  display: none;\n}\n.query-builder .rule-placeholder {\n  border: 1px dashed #bbb;\n  opacity: 0.7;\n}\n\n/*\n*/\n.svg-font-color svg > path {\n  fill: var(--ifm-font-color-base);\n}\n\n.donut-hole {\n  overflow-y: unset !important;\n}\n\n.queryBuilder {\n  min-width: 420px;\n}\n\nli.tabs__item {\n  white-space: nowrap;\n}\n\n/* Styles for when \"Use validation\" option is selected */\n.validateQuery .queryBuilder {\n  & .ruleGroup.queryBuilder-invalid {\n    /* Color invalid groups */\n    background-color: color-mix(in srgb, rebeccapurple, transparent 60%);\n\n    & .ruleGroup-addRule {\n      /* Bold the \"+ Rule\" button if the group has no child rules or groups */\n      font-weight: bold !important;\n    }\n\n    & > .ruleGroup-body {\n      display: block;\n    }\n\n    & > .ruleGroup-body::after {\n      /* Message to user about empty groups */\n      content: \"Empty groups are considered invalid. Avoid them by using addRuleToNewGroups.\";\n      color: white;\n    }\n  }\n\n  & .rule.queryBuilder-invalid .rule-value {\n    /* Purple background for empty text fields */\n    background-color: color-mix(in srgb, rebeccapurple, transparent 60%);\n\n    &::placeholder {\n      color: color-mix(in srgb, rebeccapurple, black 30%);\n    }\n  }\n}\n\n/* Styles for when \"Use validation\" option is selected (dark theme variations) */\nhtml[data-theme=\"dark\"]\n  .validateQuery\n  .queryBuilder\n  .rule.queryBuilder-invalid\n  .rule-value::placeholder {\n  color: color-mix(in srgb, rebeccapurple, white 30%);\n}\n\n.tabs-container .tabs-container li {\n  font-size: smaller;\n  padding: var(--ifm-badge-padding-vertical) var(--ifm-badge-padding-horizontal);\n}\n\n/*.results-auto li:not(:last-child)::after {\n  content: \".\"; /* Change to \"•\" for a dot * /\n  margin-left: 15px;\n  color: #aaa;\n}*/\n\n/* Adds a line under every item except the last one */\n.results-auto li:not(:last-child) {\n  border-bottom: 1px solid #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
